/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Standard` - STANDARD
 * * `Source From Template` - SOURCE_FROM_TEMPLATE
 * * `Source From Third Party` - SOURCE_FROM_THIRD_PARTY
 * * `GitHub Branch` - GITHUB_BRANCH
 * * `GitHub Pull Request` - GITHUB_PULL_REQUEST
 * * `GitHub Expansion` - GITHUB_EXPANSION
 * * `Notion Expansion` - NOTION_EXPANSION
 * * `Slack Expansion` - SLACK_EXPANSION
 */
export enum TaskLinkKind {
  STANDARD = 'Standard',
  SOURCE_FROM_TEMPLATE = 'Source From Template',
  SOURCE_FROM_THIRD_PARTY = 'Source From Third Party',
  GITHUB_BRANCH = 'GitHub Branch',
  GITHUB_PULL_REQUEST = 'GitHub Pull Request',
  GITHUB_EXPANSION = 'GitHub Expansion',
  NOTION_EXPANSION = 'Notion Expansion',
  SLACK_EXPANSION = 'Slack Expansion',
}
